import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { SHARE_SHORT_LINK_KEY } from '@pages/AdditionalServices/tabs/DeliveryForm/consts';
import { HistoryItemContent } from '@pages/History/components/ShortLinkItem/components/HistoryItemContent';
import { useHistoryItemData } from '@pages/History/components/ShortLinkItem/useHistoryItemData';
import { HistoryItem } from '@services/AuthService/query/loadUserQuery';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Пропсы компонента
 */
type HistoryMenuItemProps = {
  historyItem: HistoryItem;
};

/**
 * Элемент краткого меню истории
 */
export const HistoryMenuItem = ({ historyItem }: HistoryMenuItemProps) => {
  const { t } = useTranslation(['Actions']);
  const { paramsState } = useHistoryItemData(historyItem);

  const openCalculationHandler = () => {
    window.open(`/?${SHARE_SHORT_LINK_KEY}=` + historyItem.short_link, '_blank');
  };

  return (
    <div className="calculations-menu__item calculations-menu__item--history">
      <div className="calculations-menu__item-content">
        <HistoryItemContent historyItem={historyItem} paramsState={paramsState} />
      </div>
      {!paramsState.isLoading && (
        <div className="calculations-menu__actions">
          <Tooltip title={t('Actions:RefreshCalculation')}>
            <IconButton
              size={'small'}
              color={'inherit'}
              className="calculations-menu__accent-button"
              onClick={openCalculationHandler}
            >
              <OpenInNewIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
